import React from "react";
import { useDispatch, useSelector, useEf } from "react-redux";
import "./Notification.css";
import { Button, Card, CardContent, CardHeader } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { open } from "../../redux/actions/modalActions";
import { currentDoc } from "../../redux/actions/dataActions";

function Notification(props) {
  const dispatch = useDispatch();

  const openDialog = (doc, params) => {
    dispatch(currentDoc(doc, params))
    dispatch(open(doc, params));
  };

  return (props.popup ?
    
    <div className="text_part popup_text">
      <div className="text">{props.data?.messageContent}</div>
    </div>
    
   :    
    <Card className="Notif_card">
      <CardContent className="Notif_content">
        <div className="right_part">
          <InfoIcon className="info_icon" />
        </div>
        <div className="left_part">
          <div className="text_part">
            <div className="text">{props.data?.messageContent}</div>
          </div>
          {props.data?.popupType !== 'information' ? (
          <>
            <div className="action_part">
              <Button
                onClick={() => openDialog(props.data?.popupType, props.data?.popupUrls)}
                className="card_action"
                variant="contained"
                disableElevation
              >
                לפעולה
              </Button>
            </div>
          </>
        ) : ''}
        </div>
      </CardContent>
    </Card>
  );
};

export default Notification;
